import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
  })
export class servicesUrl {
   public url = 'https://api2.glintaps.com:444/our_team/getPost';
  public ImgUrl = 'https://api2.glintaps.com:444/images/post/';
  public url_ = 'https://api2.glintaps.com:444';
}
